import React, { FC } from 'react'
import { RichTextInput, RichTextInputToolbar, AlignmentButtons, LinkButtons, ClearButtons, useTiptapEditor } from 'ra-input-rich-text'
import { ToggleButton, ToggleButtonGroup, } from '@mui/material'
import FormatBold from '@mui/icons-material/FormatBold'
import FormatItalic from '@mui/icons-material/FormatItalic'
import FormatUnderlined from '@mui/icons-material/FormatUnderlined'

type FormHeaderInputProps = {
  source: string
  styleType: 'inline' | 'class'
  toolbarOptions?: any[]
  size?: 'small' | 'medium' | 'large'
}

export const FormHeaderInput: FC<FormHeaderInputProps> = ({ styleType = 'inline', toolbarOptions, size = 'large', ...inputProps }) => {
  // const editor = useTiptapEditor()

  return (
    <RichTextInput
      {...inputProps}
      toolbar={
        <div style={{ width: '100%' }}>
          <RichTextInputToolbar>
            <CustomFormatButtons size={size} />
            <AlignmentButtons size={size} />
            <LinkButtons size={size} />
            <ClearButtons size={size} />
          </RichTextInputToolbar>
        </div>
      }
    />
  )
}

const CustomFormatButtons = ({ size }: { size: 'small' | 'medium' | 'large' }) => {
  const editor = useTiptapEditor()
  return (
    <ToggleButtonGroup>
      <ToggleButton value="bold" aria-label='Bold' title='Bold' size={size} onClick={() => editor.chain().focus().toggleBold().run()}>
        <FormatBold fontSize="inherit" />
      </ToggleButton>
      <ToggleButton value="italic" aria-label='Italic' title='Italic' size={size} onClick={() => editor.chain().focus().toggleItalic().run()}>
        <FormatItalic fontSize="inherit" />
      </ToggleButton>
      <ToggleButton value="underline" aria-label='Underline' title='Underline' size={size} onClick={() => editor.chain().focus().toggleUnderline().run()}>
        <FormatUnderlined fontSize="inherit" />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}